import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import ContentWrapper from '../content_wrapper/ContentWrapper';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import moment from 'moment';
import 'moment/locale/ru';
import 'moment/locale/kk';
import {
  DatePicker,
  TimePicker,
  Select,
  Spin,
  Input,
  message,
  Tag,
  Checkbox, Alert
} from 'antd';
import {
  ADD_MSISDNS,
  ADD_MSISDNS_FROM_CONTACTS,
  ADD_MSISDNS_FROM_GROUPS,
  ADD_MSISDNS_FROM_FILE,
  SHOW_MSISDNS,
  PREVIEW_CAMPAIGN,
  CAMPAIGNS_RESOURCE_NAME,
  SENDERS_RESOURCE_NAME,
  MAX_DAYS_BEFORE_SMS_CAMPIGN,
  CREATE_DRAFT,
  CREATE_AND_SEND,
  SEND_CAMPAIGN,
  UPDATE_DRAFT
} from '../../config/constants';
import {
  Drawer,
  Dropdown,
  Button,
  Icon,
  Tooltip,
  Popconfirm
} from 'antd';
import AnimateEnter from '../AnimateEnter';
import { countSmsSegments, grammarNumbers } from '../../Utils';
import { withCancellablePromise } from '../../hocs/withCancellablePromise';
import { _callResource } from '../../context/_callResource';
import MESSAGES from '../../locale/messages';
import TEXTS from '../../locale/texts';
import localeRu from 'antd/es/date-picker/locale/ru_RU';
import localeEn from 'antd/es/date-picker/locale/en_US';
import { renderMenuAddContacts } from './partials/renderMenuAddContacts';
import { renderMenuSmsData } from './partials/renderMenuSmsData';
import { renderModalForm } from './partials/renderModalForm';
import { actionsCampaign } from './partials/actionsCampaign';
import { handleDateChange } from './partials/handleDateChage';

const { TextArea } = Input;

class NewCampaign extends Component {
  state = {
    // data that is sent
    // to backend to create
    // new sms-campaign
    PAYLOAD: {
      id: null,
      name: null,
      branchId: 1,
      msisdns: [],
      scheduleTime: null,
      sender: null,
      smsBody: null,
      isMsisdnsWithData: false, // if campaign is with msisdns individual data
      smsBodyMeta: null
    },
    day: {
      value: null,
      text: null
    },
    time: {
      value: null,
      text: null
    },
    dataFromFile: null,
    senders: [],
    senderIsMounted: false,
    sendNow: false,
    message: '', // error message
    placement: 'bottom',
    modalName: null,
    drawerVisible: false,
    error: false,
    errorMessage: null,
    isLoadingSenders: true,
    isEdit: !!this.props.match.path.match(/edit/),
    createDraftCampaignsIsLoading: false,
    createDraftCampaignsError: null,
    updateDraftCampaignsIsLoading: false,
    updateDraftCampaignsError: null,
    sendCampaignsIsLoading: false,
    sendCampaignsError: null,
    globalMessage: null,
    sendersDataError: null,
    isLoadingInitialData: true,
    withParamsDisabled: false
  };

  callResource = _callResource.bind(this);
  nameInput = React.createRef();
  smsBodyInput = React.createRef();

  // SAVE EDITED DRAFT CAMPAIGN
  updateDraftCampaign = () => { actionsCampaign.bind(this)(UPDATE_DRAFT); };

  // CREATE DRAFT CAMPAIGN, WITHOUT SENDING IT YET
  createDraftCampaign = () => { actionsCampaign.bind(this)(CREATE_DRAFT); };

  // CREATE NEW CAMPAIGN AND SEND IT IMMEDIATELY
  createAndSendCampaign = () => { actionsCampaign.bind(this)(CREATE_AND_SEND); };

  // SEND PREVIOUSLY SAVED DRAFT CAMPAIGN
  sendCampaign = () => { actionsCampaign.bind(this)(SEND_CAMPAIGN); };

  toAllCampaigns = () => { this.props.history.push('/'); };

  addContactsHandle = ({ key }) => {
    switch(key) {
      case 'manual': this.showDrawer(ADD_MSISDNS); break;
      case 'from_contacts': this.showDrawer(ADD_MSISDNS_FROM_CONTACTS); break;
      case 'from_groups': this.showDrawer(ADD_MSISDNS_FROM_GROUPS); break;
      case 'from_file': this.showDrawer(ADD_MSISDNS_FROM_FILE); break;
      default: this.showDrawer(ADD_MSISDNS);
    }
  };

  updateSmsBodyMeta = (smsBodyMeta) => {
    this.setState(({ PAYLOAD }) => ({
      PAYLOAD: { ...PAYLOAD, smsBodyMeta } }));
  };

  showDrawer = (modalName, prevModal) => {
    this.setState({
      drawerVisible: true,
      modalName,
      prevModal
    });
  };

  hideDrawer = () => {
    const { prevModal } = this.state;
    this.setState({
      drawerVisible: false,
      modalName: null
    });

    if (prevModal) {
      this.showDrawer(prevModal)
    }
  };

  getCampaignData = async () => {
    const { id, promiseCancelToken } = this.props;
    this.callResource({
      resourceName: CAMPAIGNS_RESOURCE_NAME,
      apiClassName: 'campaigns',
      action: 'getOneOf',
      apiCallParams: { id },
      showLoading: false,
      promiseCancelToken,
      onSuccess: ({ data: campaignData }) => {
        if (campaignData.scheduleTime) {
          this.onDateChange(moment(campaignData.scheduleTime));
          this.onTimeChange(
            moment(campaignData.scheduleTime),
            moment(campaignData.scheduleTime).format('HH:mm')
          );
        }
        this.setState({
          PAYLOAD: campaignData,
          sendNow: !(!!campaignData.scheduleTime)
        });
      }
    });
  };

  getSenders = () => {
    const { promiseCancelToken, location: { state: locationState } } = this.props;
    this.callResource({
      resourceName: SENDERS_RESOURCE_NAME,
      apiClassName: 'senders',
      action: 'get',
      promiseCancelToken,
      onSuccess: ({ data }) => {
        const senders = data.map(({ sender }) => sender);
        this.setState({
          isLoadingSenders: false,
          senderIsMounted: true,
          senders
        });
        if (!locationState) {
          this.setState({
            PAYLOAD: {
              ...this.state.PAYLOAD,
              sender: senders[0]
            }
          });
        }
      },
      onError: () => {
        this.setState({
          isLoadingSenders: false,
          senderIsMounted: true
        });
      }
    });
  };

  componentDidMount() {
    window.scrollTo(0, 86);
    const { location: { state: locationState } } = this.props;
    const { isEdit, PAYLOAD } = this.state;

    // for editable campaigns
    // if we are editing saved campaign
    // or if we copied campaign
    // to create a new one -
    // we pass state object to history
    // from previous page via location state
    if (locationState) {
      const {
        name,
        sender,
        msisdns,
        scheduleTime,
        smsBody,
        isMsisdnsWithData,
        smsBodyMeta
      } = locationState;

      if (isEdit) {
        if (scheduleTime) {
          this.onDateChange(moment(scheduleTime));
          this.onTimeChange(
            moment(scheduleTime),
            moment(scheduleTime).format('HH:mm')
          );
        }
        this.setState({
          PAYLOAD: locationState,
          sendNow: !(!!scheduleTime)
        });
      } else {
        // copied campaign
        // we pass only certain
        // parameters
        this.setState({
          PAYLOAD: {
            ...PAYLOAD,
            name: `${name} COPY`,
            sender, smsBody, msisdns,
            isMsisdnsWithData,
            smsBodyMeta
          }
        });
      }
    } else {
      // request for data if we are editing campaign
      // and we have no data passed via location state
      isEdit && this.getCampaignData();
    }

    this.nameInput.current.focus();

    // get all available senders
    this.getSenders();
  }

  onInputChange = (key, value) => {
    this.setState(({ PAYLOAD }) => ({
      PAYLOAD: {
        ...PAYLOAD,
        [key]: value
      },
      message: ''
    }));
  };

  onDateChange = (date) => {
    handleDateChange.bind(this)(date);
  };

  disabledDate = (current) => {
    return current < moment().startOf('day')
      || current > moment().add(MAX_DAYS_BEFORE_SMS_CAMPIGN, 'days');
  };

  onTimeChange = (time, timeString) => {
    this.setState({
      time: {
        value: time,
        text: time ? timeString + ':00' : null
      },
      message: ''
    });
  };

  onSenderChange = (newSender) => {
    const { sender } = this.state.PAYLOAD;
    if (newSender !== sender) {
      this.setState((prevState) => ({
        PAYLOAD: {
          ...prevState.PAYLOAD,
          sender: newSender
        }
      }));
    }
  };

  onPreview = (event) => {
    const { lang } = this.props;
    const { PAYLOAD, day, time, sendNow } = this.state;
    const { name, msisdns, sender, smsBody, isMsisdnsWithData } = PAYLOAD;

    const formIsFilledOut = name && sender && smsBody && msisdns.length > 0
      && (sendNow || (day.value && time.value));

    if (formIsFilledOut) {
      if (!isMsisdnsWithData && !!smsBody.match(/PARAM/)) {
        this.setState({
          message: TEXTS.withMsisdnsDataSync[lang]
        });
        return null;
      }

      let campaignScheduleDate = null;

      if (!sendNow) {
        campaignScheduleDate = `${day.text} ${time.text}`;
      }

      this.setState(prevState => ({
        PAYLOAD: {
          ...prevState.PAYLOAD,
          scheduleTime: campaignScheduleDate
        },
        message: ''
      }));

      this.showDrawer(event.target.name);
    } else {
      this.setState({
        message: TEXTS.fillAllTheFields[lang]
      });
    }
  };

  onCheck = (event) => {
    const checked = event.target.checked;
    if (checked) {
      this.setState({
        day: {
          value: null,
          text: null
        },
        time: {
          value: null,
          text: null
        },
        sendNow: true
      });
    } else {
      this.setState({
        sendNow: false
      });
    }
  };

  toggleWithParams = () => {
    this.setState(({ PAYLOAD }) => ({
      PAYLOAD: {
        ...PAYLOAD,
        isMsisdnsWithData: !PAYLOAD.isMsisdnsWithData
      }
    }));
  };

  // called after removing msisdns
  // from msisdns list in the modal
  substituteMsisdns = (contactsArray) => {
    const { PAYLOAD } = this.state;
    const { lang } = this.props;
    const oldMsisdnsCount = PAYLOAD.msisdns.length;
    const msisdns = contactsArray.map(({ msisdn }) => msisdn);

    this.setState(({ PAYLOAD, withParamsDisabled }) => ({
      msisdnList: contactsArray,
      PAYLOAD: {
        ...PAYLOAD,
        msisdns: contactsArray
      },
      withParamsDisabled: contactsArray.length === 0
        ? false : withParamsDisabled
    }));

    const deletedNumbers = oldMsisdnsCount - msisdns.length;
    message.success(MESSAGES.contactsRemoved(deletedNumbers)[lang], 3);
  };

  // add new msisdns from file
  // or contacts, or groups,
  // or manually added
  updateMsisdns = (newContactsArray = null, withParamsDisabled) => {
    const { lang } = this.props;
    const { PAYLOAD: { msisdns } } = this.state;
    const oldPayloadMsisdnsCount = msisdns.length;
    const newMsisdnsCount = newContactsArray.length;

    // plain msisdns array to search for duplicates
    const msisdnsFromState = msisdns.map(({ msisdn }) => msisdn);

    const uniqueMsisdns = msisdns.length > 0
      ? [...msisdns, ...(newContactsArray.filter(({ msisdn }) => {
          return msisdnsFromState.indexOf(msisdn) === -1;
        }))]
      : newContactsArray;

    const finalMsisdnsCount = uniqueMsisdns.length;
    const addedMsisdnsCount = finalMsisdnsCount - oldPayloadMsisdnsCount; // how many new msisdns
    const existedMsisdnsCount = newMsisdnsCount + oldPayloadMsisdnsCount - finalMsisdnsCount;
    const existedMsisdnString = existedMsisdnsCount > 0
      ? `, ${MESSAGES.manyExcludedContactFromCampaign(existedMsisdnsCount)[lang]}`
      : '';

    console.log('updateMsisdns - msisdns previous state:', msisdns);
    console.log('updateMsisdns - uniqueMsisdns array:', uniqueMsisdns);
    console.log('updateMsisdns - newContactsArray:', newContactsArray);
    console.log('updateMsisdns - oldPayloadMsisdnsCount:', oldPayloadMsisdnsCount);
    console.log('updateMsisdns - new total msisdns count without duplicates:', newMsisdnsCount + oldPayloadMsisdnsCount);

    // SHOW MESSAGE
    message.success(`${MESSAGES.contactIsAdded(addedMsisdnsCount)[lang]}${existedMsisdnString}`, 3);

    // RESULT MSISDNS FOR PAYLOAD
    // set unique msisdns to send to api
    // and msisdnsList for creating tables
    // inside different modals
    this.setState((prevState) => ({
      PAYLOAD: {
        ...prevState.PAYLOAD,
        msisdns: uniqueMsisdns
      },
      message: '',
      withParamsDisabled: !!withParamsDisabled || false
    }));
  };

  clearMsisdnList = () => {
    const { PAYLOAD } = this.state;
    const msisdnsToDelete = PAYLOAD.msisdns.length;
    message.success(`${grammarNumbers(msisdnsToDelete, ['Удален', 'Удалено', 'Удалено'])} ${msisdnsToDelete} ${grammarNumbers(msisdnsToDelete, ['номер', 'номера', 'номеров'])}`, 10);
    this.setState(({ PAYLOAD }) => ({
      msisdnList: [],
      PAYLOAD: {
        ...PAYLOAD,
        msisdns: [],
        smsBodyMeta: null
      },
      dataFromFile: null,
      withParamsDisabled: false
    }));
  };

  addDataHandle = ({ key }) => {
    this.setState((prevState) => {
      const currentSmsBody = prevState.PAYLOAD.smsBody || '';
      return {
        PAYLOAD: {
          ...prevState.PAYLOAD,
          smsBody: `${currentSmsBody}%PARAM${key}%`
        }
      }
    }, () => {
      this.smsBodyInput.current.focus();
    });
  };

  render() {
    const {
      PAYLOAD,
      day,
      time,
      modalName,
      message,
      sendNow,
      senders: _senders,
      drawerVisible,
      placement,
      isEdit,
      isLoadingSenders,
      senderIsMounted,
      sendersDataError,
      withParamsDisabled
    } = this.state;

    const { name, msisdns, smsBody, smsBodyMeta, isMsisdnsWithData } = PAYLOAD;
    const { lang } = this.props;
    const isMsisdnListEmpty = msisdns.length === 0;

    moment.locale(lang);

    const sendersNew = _senders ? _senders.map((item, i) => {
      return <Select.Option value={item} key={i}>{item}</Select.Option>;
    }) : [];

    const smsBodyMaxSymbols = (() => {
      if (!smsBody) return 0;
      if (isMsisdnsWithData && !!smsBodyMeta) {
        const maxSymbols = smsBodyMeta ? smsBodyMeta.maxSymbols : 0;
        return smsBody.replace(/%PARAM\d%/g, '').length + maxSymbols;
      } else {
        return smsBody.length;
      }
    })();

    const smsBodySegmentsCount = (() => {
      if (!smsBody) return 0;
      if (isMsisdnsWithData && !!smsBodyMeta) {
        const isAscii = smsBodyMeta ? smsBodyMeta.isAscii : false;
        return countSmsSegments(smsBody, isAscii);
      } else {
        return countSmsSegments(smsBody);
      }
    })();

    return (
      <div>
        <ContentWrapper>
          <h4 className="form-row title text-pink text-uppercase mb-4">
            {`${isEdit ? TEXTS.editCampaignTitle[lang] : TEXTS.createCampaignTitle[lang]}`}
          </h4>
          <div>
            <div className="form-row mb-4">
              <label>
                {TEXTS.campaignNameLabel[lang]}
              </label>
              <Input
                size="large"
                name="name"
                placeholder={TEXTS.campaignNameLabel[lang]}
                ref={this.nameInput}
                value={name || ''}
                onChange={({ target: { name, value } }) =>
                  this.onInputChange(name, value)
                }
              />
            </div>
            <div className="form-row mb-4">
              <label style={{width: '100%'}}>
                {TEXTS.campaignSmsBodyLabel[lang]}
              </label>
              {isMsisdnsWithData
                && <Dropdown overlay={renderMenuSmsData({ lang, addDataHandle: this.addDataHandle })}>
                      <Button style={{height: 40, marginLeft: 0, marginBottom: 10}}>
                        <Icon type="solution" style={{position: 'relative', top: -2, fontSize: 16}} />
                        {TEXTS.btnAddDataToSmsCampaign[lang]} <Icon type="down" style={{position: 'relative', top: -2, fontSize: 16}} />
                      </Button>
                    </Dropdown>}
              <TextArea
                name="smsBody"
                rows="4"
                placeholder={TEXTS.thSmsBody[lang]}
                maxLength="1000"
                ref={this.smsBodyInput}
                value={PAYLOAD.smsBody || ''}
                onChange={({ target: { name, value } }) =>
                  this.onInputChange(name, value)
                }
              />
              <div className="d-flex justify-content-between w-100">
                <label className="small" style={{position: 'relative'}}>
                  {
                    isMsisdnsWithData
                      ? TEXTS.campaignSmsBodySymbolsCountMax[lang]
                      : TEXTS.campaignSmsBodySymbolsCount[lang]
                  }
                  {': '}{smsBodyMaxSymbols}
                  {
                    isMsisdnsWithData &&
                      <Tooltip title={TEXTS.segmentsTooltip[lang]}>
                        <Icon type="info-circle" style={{position: 'absolute', top: 5, right: -17}} />
                      </Tooltip>
                  }
                </label>
                <label className="small">
                  {
                    isMsisdnsWithData
                      ? TEXTS.campaignSmsBodySegmentsCountMax[lang]
                      : TEXTS.campaignSmsBodySegmentsCount[lang]
                  }
                  {': '}{smsBodySegmentsCount}
                </label>
              </div>
            </div>
            <div className="form-row schedule-time mb-4 flex-direction-column">
              <label>{TEXTS.campaignDateTimeLabel[lang]}</label>
              <div className="d-flex align-items-center">
                <DatePicker
                  className="mr-3"
                  size="large"
                  placeholder={TEXTS.campaignDatePlaceholder[lang]}
                  format="DD-MM-YYYY"
                  value={day.value}
                  disabled={sendNow}
                  disabledDate={this.disabledDate}
                  onChange={this.onDateChange}
                  locale={lang === 'en' ? localeEn : localeRu}
                />
                <TimePicker
                  size="large"
                  minuteStep={5}
                  format="HH:mm"
                  value={time.value}
                  disabled={sendNow || !day.value}
                  placeholder={TEXTS.campaignTimePlaceholder[lang]}
                  onChange={this.onTimeChange}
                />
                <div style={{marginLeft: 10}}>
                  <Checkbox
                    checked={sendNow}
                    onChange={this.onCheck}>
                    {TEXTS.campaignSendNow[lang]}
                  </Checkbox>
                </div>
              </div>
            </div>
            <div className="form-row mb-4">
              <div>
                <label style={{display: 'block'}}>
                  {TEXTS.campaignSenderLabel[lang]}
                </label>
                {!isLoadingSenders && !sendersDataError
                   && <AnimateEnter in={senderIsMounted}>
                        <Select defaultValue={PAYLOAD.sender || (_senders ? _senders[0] : '')} size="large"
                              style={{ width: 172 }} onChange={this.onSenderChange}
                              value={PAYLOAD.sender}>
                          {sendersNew}
                        </Select>
                      </AnimateEnter>}
                {isLoadingSenders
                  && <Spin style={{height: 40}} />}

                {sendersDataError
                  && <Alert
                       description={TEXTS.campaignSendersError[lang]}
                       type="error"
                     />}
              </div>
            </div>
            <div className="form-row mb-4">
              <div>
                <label style={{display: 'block'}}>
                  {TEXTS.campaignReceiversParamsLabel[lang]}
                  <Tooltip
                    title={TEXTS.smsParamsTooltip[lang]}>
                    <Icon type="info-circle" style={{ position: 'relative', top: -3, marginLeft: 3 }} />
                  </Tooltip>
                </label>
                <div>
                  <Checkbox
                    disabled={withParamsDisabled}
                    checked={PAYLOAD.isMsisdnsWithData}
                    onChange={this.toggleWithParams}>
                    {TEXTS.campaignContainsParams[lang]}
                  </Checkbox>
                </div>
              </div>
            </div>
            <div className="form-row mb-4">
              <div>
                <div>
                  <label>
                    {TEXTS.campaignReceiversLabel[lang]}
                    <Tag color="geekblue"
                         title={TEXTS.showAllReceiversForCampaign[lang]}
                         style={{
                           position: 'relative',
                           top: -2,
                           marginLeft: 5,
                           padding: '0 8px',
                           verticalAlign: 'middle',
                           fontSize: 16,
                           fontWeight: 700,
                           lineHeight: '26px',
                           cursor: 'pointer'
                         }}
                         onClick={() => this.showDrawer(SHOW_MSISDNS)}
                    >{PAYLOAD.msisdns.length}</Tag>
                  </label>
                  {!isMsisdnListEmpty ?
                    <Popconfirm
                      placement="right"
                      title={TEXTS.areYouSureToClearContacts[lang]}
                      okText={TEXTS.yes[lang]}
                      cancelText={TEXTS.btnToCancel[lang]}
                      onConfirm={this.clearMsisdnList}
                    >
                      <Tag
                        color="red"
                        title={TEXTS.btnRemoveAllMsisdnsFromCampaign[lang]}
                        style={{
                          position: 'relative',
                          top: -2,
                          padding: '0 8px',
                          verticalAlign: 'middle',
                          fontSize: 16,
                          lineHeight: '26px',
                          cursor: 'pointer'
                        }}>
                        <Icon type="delete" style={{position: 'relative', fontSize: 16, top: -4}} />
                      </Tag>
                    </Popconfirm>
                    : ''}
                    <Tooltip
                      title={TEXTS.smsReceiversTooltip[lang]}>
                      <Icon type="info-circle"
                            style={{ position: 'relative', top: -4 }} />
                    </Tooltip>
                </div>
                <p>
                  {TEXTS.campaignContactsNumberDisclaimer[lang]}
                </p>
                <div className="campaign-msisdns">
                  <Dropdown
                    overlay={
                      renderMenuAddContacts({
                        lang, hasParams: PAYLOAD.isMsisdnsWithData,
                        addContactsHandle: this.addContactsHandle
                      })
                    }>
                    <Button
                      style={{
                        height: 40,
                        marginLeft: 0,
                        marginRight: 10,
                        verticalAlign: 'middle'
                      }}>
                        <Icon type="usergroup-add" style={{position: 'relative', top: -2, fontSize: 18}} />
                        {TEXTS.btnAddReceivers[lang]} <Icon type="down" style={{position: 'relative', top: -2, fontSize: 16}} />
                    </Button>
                  </Dropdown>
                  {!isMsisdnListEmpty ?
                    <Button
                      style={{
                        height: 40,
                        verticalAlign: 'middle'
                      }}
                      onClick={() => this.showDrawer(SHOW_MSISDNS)}
                    >
                      <Icon type="unordered-list" style={{position: 'relative', top: -3}} />
                      {TEXTS.showAllReceivers[lang]}
                    </Button>
                    : ''}
                </div>
              </div>
            </div>
            <div className="form-row">
              <Button
                type="primary"
                size="large"
                style={{padding: '0 20px', height: 50, marginRight: 15, fontSize: 15}}
                name={PREVIEW_CAMPAIGN}
                onClick={this.onPreview}
              >
                {TEXTS.btnPreview[lang]}
              </Button>
              <Button
                size="large"
                style={{padding: '0 20px', height: 50, fontSize: 15}}
                onClick={this.toAllCampaigns}
              >
                {TEXTS.btnCancel[lang]}
              </Button>
            </div>
          </div>
          {message &&
            <div className="form-row">
              <div className="alert alert-warning mt-3">
                {message}
              </div>
            </div>}
        </ContentWrapper>
        <Drawer
          placement={placement}
          closable={false}
          onClose={this.hideDrawer}
          visible={drawerVisible}
        >
          {renderModalForm.bind(this)(modalName)}
        </Drawer>
      </div>
    );
  }
}

export default withCancellablePromise(withRouter(NewCampaign), 'createDraftCampaign');
